import { Chip } from "@mui/material";
import { translateOrderStatus } from "data/functions";
import { constants } from "data/globals";

export const OrderChip = (props) => {
  let color = props?.color
    ? props?.color
    : translateOrderStatus(props?.title) === constants.ruCANCELED
    ? "error"
    : translateOrderStatus(props?.title) === constants.ruCOMPLETED
    ? "dimgrey"
    : translateOrderStatus(props?.title) === constants.ruPAY_WAITING
    ? "secondary"
    : translateOrderStatus(props?.title) === constants.ruIN_WORK
    ? "warning"
    : translateOrderStatus(props?.title) === constants.ruREADY ||
      translateOrderStatus(props?.title) === constants.ruPAID
    ? "dimgreen"
    : undefined;
  return (
    color && (
      <Chip
        color={color}
        label={translateOrderStatus(props?.title)}
        sx={{
          "& .MuiChip-label": {
            display: "block",
            // whiteSpace: "normal",
            fontSize: "10px",
            lineHeight: "1.1",
            textAlign: "center",
          },
          height: "auto",
          // minHeight: "16px",
          // maxWidth: "80px",
          // marginTop: "-12px",
          margin: "0",
          padding: "2px",
        }}
      />
    )
  );
};
